import React from 'react';

import { ReactComponent as UploadIcon } from "../../styles/icon/upload.svg";
import Button from "../../elements/Button/Button";
import styles from './CertificateUpload.module.scss';
import strings from '../../lang/lang';

interface ICertificate {
  onClick: () => void;
}

const CertificateUpload = ({ onClick }: ICertificate) => {
  return (
    <div className={styles.certificate_upload}>
      {/*<div className={styles.certificate_upload__title}>Certificate</div>
        <p className={styles.certificate_upload__desc}>
          If you have your Certificate Signing Request (CSR)
        </p>*/}
        <Button
          type="button"
          name={strings.certificateUpload.buttons.upload}
          variant="primary"
          secondaryClassName="lg"
          onClick={onClick}
        >
          <UploadIcon />
        </Button>
    </div>
  )
};

export default CertificateUpload;
